import React, { useContext } from "react";

/// React router dom
import { Switch, Route, Redirect, useLocation, useParams } from "react-router-dom";
import { FeatureRoute } from "../routeguards/FeatureRoute";

import { CapabilityRoute } from "../routeguards/CapabilityRoute";
import { BillingContentGate } from '../routeguards/BillingAccessGate';

/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";
import ScrollToTop from "./layouts/ScrollToTop";
import MobileMenuToggle from "./layouts/MobileMenuToggle";

/// Dashboard
import Home from "./components/Dashboard/Home";
import DashBoardWidget from "./components/Dashboard/DashBoardWidget";
// import InvoicesList from "./components/Dashboard/InvoicesList";

import ManualBookkeepingEntry from "./components/Bookkeeping/ManualBookkeepingEntry";

/// Dashboard - Verifications
import Verifications from "./components/Accounting/Verification/Verifications";

import BookkeepingChatInterface from "./components/Bookkeeping/BookkeepingChatInterface";

import FiscalYearDetails from "./components/Accounting/FiscalYearDetails";

import EmployeeList from "./components/AppsMenu/Personell/EmployeeList";
import NewEmployee from "./components/AppsMenu/Personell/NewEmployee";
import EditEmployee from "./components/AppsMenu/Personell/EditEmployee";
import ViewEmployee from "./components/AppsMenu/Personell/ViewEmployee";

import NewContract from "./components/AppsMenu/Personell/NewContract";
import EditContract from "./components/AppsMenu/Personell/EditContract";

import TimesheetPage from "./components/AppsMenu/TimeReporting/TimesheetPage";
import ProjectsPage from "./components/AppsMenu/Projects/ProjectsPage";
import ProjectDetailsPage from "./components/AppsMenu/Projects/ProjectDetailsPage";
import ProjectEditPage from "./components/AppsMenu/Projects/ProjectEditPage";
import ProjectReportsPage from "./components/AppsMenu/Projects/ProjectReportsPage";
import ApprovalPage from "./components/AppsMenu/TimeReporting/ApprovalPage";
import SemesterPage from "./components/AppsMenu/Salary/SemesterPage";
import ExpensesPage from "./components/AppsMenu/Expenses/ExpensesPage";
import ExpenseApprovalQueuePage from "./components/AppsMenu/Expenses/ExpenseApprovalQueuePage";
import TodoPage from "./components/AppsMenu/ToDo/TodoPage";
import { TodoProvider } from "./components/AppsMenu/ToDo/TodoContext";
import DocumentsPage from "./components/Documents/DocumentsPage";
import ReportsPage from "./components/AppsMenu/TimeReporting/ReportsPage";
import RetentionPage from "./components/AppsMenu/TimeReporting/RetentionPage";

import PayrollPeriods from "./components/AppsMenu/Salary/PayrollPeriods";
import MonthlyPayrollPeriod from "./components/AppsMenu/Salary/MonthlyPayrollPeriod";
import Payslip from "./components/AppsMenu/Salary/Payslip";

import CreateSupplierInvoice from "./components/AppsMenu/supplier-invoices/CreateSupplierInvoice";
import InboxPage from "./components/AppsMenu/inbox/InboxPage";
import InvoiceList from "./components/AppsMenu/Invoices/InvoiceList";
import ViewInvoice from "./components/AppsMenu/Invoices/ViewInvoice";
import CustomersTable from "./components/AppsMenu/Factoring/Customers/CustomersTable";
import ViewCustomerDetailed from "./components/AppsMenu/Factoring/Customers/ViewCustomerDetailed";
import ViewSupplierDetailed from "./components/AppsMenu/Factoring/Suppliers/ViewSupplierDetailed";
import SuppliersTable from "./components/AppsMenu/Factoring/Suppliers/SuppliersTable";
import ArticlesTable from "./components/AppsMenu/Factoring/Articles/ArticlesTable";
import InvoiceForm from "./components/AppsMenu/Invoices/InvoiceForm";
import CreditNoteForm from "./components/AppsMenu/Invoices/CreditNoteForm";

// New invoice form
import InvoiceDetailBootstrap from "./components/AppsMenu/Invoices/newinvoiceform/InvoiceDetailBootstrap";

import CreditNoteGenerator from "./components/AppsMenu/Invoices/newinvoiceform/CreditNoteGenerator";


import SupplierInvoiceList from "./components/AppsMenu/supplier-invoices/SupplierInvoiceList";
import ViewSupplierInvoice from "./components/AppsMenu/supplier-invoices/ViewSupplierInvoice";

import AssetList from "./components/Accounting/Assets/AssetList";
import AssetDetail from "./components/Accounting/Assets/AssetDetail";
import AssetTaxStep from "./components/Accounting/Assets/TaxStep";
import AssetRegisterReport from "./components/Reporting/Assets/AssetRegisterReport";
import AssetNoteReport from "./components/Reporting/Assets/AssetNoteReport";

// import QuoteList from "./components/AppsMenu/Quotes/QuotesList";
// import QuoteForm from "./components/AppsMenu/Quotes/QuoteForm";
// import ViewQuote from "./components/AppsMenu/Quotes/QuoteViewer";

// import QuoteGeneratorBootstrap from "./components/AppsMenu/Quotes/newquotes/QuoteGeneratorBootstrap";


import CreateBookkeepingEntry from "./components/Bookkeeping/BookkeepingEntryWizard";

import CreateVerificationFromCopy from "./components/Accounting/Verification/CreateCopyVerification";
import EditVerification from "./components/Accounting/Verification/EditVerification";

import ViewSchedule from "./components/AppsMenu/Scheduling/ViewSchedule";

import CompanySettings from "./components/Settings/CompanySettings";
import TemplateEditor from "./components/Settings/TemplateEditor";

import VatReportingPeriods from "./components/Reporting/Vat/VatReportingPeriods";
import VatPeriodDetails from "./components/Reporting/Vat/VatPeriodDetails";
import PeriodiskSammanstallning from "./components/Reporting/Vat/PeriodiskSammanstallning";
import VatPeriodStepper from "./components/Reporting/Vat/VatPeriodStepper";

import YearEndPage from "./components/YearEnd/YearEndPage";
import TaxPlanningPage from "./components/TaxPlanning/TaxPlanningPage";

import MainLedgerReport from "./components/Reporting/Ledger/MainLedgerReport";
import BalanceReport from "./components/Reporting/Balance/BalanceReport";
import ResultReport from "./components/Reporting/Result/ResultReport";


/// Pages
import Registration from "./pages/Registration";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";
import FeatureDisabledPage from "./pages/FeatureDisabledPage";
import { ThemeContext } from "../context/ThemeContext";
import { useFeatures } from "../context/FeatureContext";
import AgentEmailBanner from "./components/AgentEmailBanner";

import UserSettings from "./components/Settings/UserSettings";

import AcceptInvite from "./pages/AcceptInvite";

import GenericImporter from "./components/SharedComponents/GenericImporter";

import OnboardingWizard from "./components/Onboarding/OnboardingWizard";
import WhatFinnKnowsPage from "./components/Settings/WhatFinnKnowsPage";

import BankhandelserPage from "./components/Banking/BankhandelserPage";
import ByraQueuePage from "./components/Banking/ByraQueuePage";
import BankAccountMappings from "./components/Banking/BankAccountMappings";
import SkattekontoPage from "./components/Skatteverket/SkattekontoPage";
import SkatteverketImporter from "./components/Skatteverket/SkatteverketImporter";


// Legacy /matching deep links land on the merged Bankhändelser home.
const MatchingRedirect = () => {
  const { companyId } = useParams();
  return <Redirect to={`/${companyId}/bankstatements`} />;
};

// Legacy Matchning sub-pages → Inställningar → Automatisering (Phase D).
// Router state (the "Skapa regel?" prefill) is forwarded so the CTA keeps
// working through the redirect.
const AutomationRedirect = () => {
  const { companyId } = useParams();
  const location = useLocation();
  return <Redirect to={{ pathname: `/${companyId}/settings/automation`, state: location.state }} />;
};

const ProtectedRoute = ({ requiredFeature, ...props }) => <FeatureRoute {...props} feature={requiredFeature} />;


const Markup = () => {
  const { menuToggle } = useContext(ThemeContext);
  const { features, isLoading, entitlements } = useFeatures();

  // useLocation (not window.location) so the wrapper classes below update on
  // in-app navigation — window.location doesn't trigger a re-render.
  const location = useLocation();
  const segments = location.pathname.split("/");
  const companyId = segments[1];

  const path = segments[segments.length - 1];
  const billingBlocked = entitlements?.billingAccess?.allowed === false;
  const pagePath = !billingBlocked && path.split("-").includes("page");
  // The Finn chat owns its header/scroll/input and fills the content area
  // edge-to-edge; the container-md cap would letterbox it beside the sidebar.
  const fullBleed = !billingBlocked && path === "ai-assistant";

  const routes = [
    /// Dashboard
    {
      url: "",
      component: Home
    },
    {
      url: ":companyId/dashboard",
      component: Home
    },
    {
      url: ":companyId/dashboard2",
      component: DashBoardWidget, intent: 'read',
      requiredFeature: "dashboard_widget"
    },
    {
      url: ":companyId/onboarding",
      component: OnboardingWizard,
    },

    {
      // Bankhändelser — THE bank-transaction home (UX redesign Phase C):
      // the merged queue + ledger. Gated on banking_integration only;
      // ai_reconciliation progressively enhances the same page (B9) —
      // deterministic matching is available to every banking tenant (D4).
      url: ":companyId/bankstatements",
      component: BankhandelserPage, intent: 'read', requiredFeature: "bank_reconciliation"
    },
    {
      url: ":companyId/skattekonto",
      component: SkattekontoPage, intent: 'read', requiredFeature: "tax_account"
    },
    {
      url: ":companyId/skatteverket/import",
      component: SkatteverketImporter, requiredFeature: "tax_account"
    },
    {
      url: ":companyId/bank-accounts",
      component: BankAccountMappings, requiredFeature: "bank_reconciliation"
    },
    {
      // Legacy Matchning URL → the merged Bankhändelser home (Phase C).
      // Kept as a redirect for one release so bookmarks/deep links survive.
      url: ":companyId/matching",
      component: MatchingRedirect,
    },
    {
      // Legacy Regler/Insikter URLs → Settings → Automatisering (Phase D).
      url: ":companyId/matching/rules",
      component: AutomationRedirect,
    },
    {
      url: ":companyId/matching/insights",
      component: AutomationRedirect,
    },
    {
      // Byråöversikt (Phase 4) — the accounting-firm cross-client exception
      // queue. Its own 'byra_tier' entitlement, reached via the "Byråöversikt"
      // header link on Matchning. Routes render with `exact`, so this deeper
      // path coexists with :companyId/matching above.
      url: ":companyId/matching/byra",
      component: ByraQueuePage,
      requiredFeature: "byra_tier"
    },

    {
      url: ":companyId/:importType/import",
      component: GenericImporter, requiredFeature: ({match}) => ({articles:'product_catalog',customers:'customer_management',suppliers:'supplier_management',transactions:'banking_integration'}[match.params.importType?.toLowerCase()] || '__unknown_import__')
    },

    {
      url: ":companyId/customers",
      component: CustomersTable, intent: 'read', requiredFeature: "customer_management"
    },

    {
      url: ":companyId/customers/:customerId",
      component: ViewCustomerDetailed, intent: 'read', requiredFeature: "customer_management"
    },
    {
      url: ":companyId/articles",
      component: ArticlesTable, intent: 'read', requiredFeature: "product_catalog"
    },
    {
      url: ":companyId/suppliers",
      component: SuppliersTable, intent: 'read', requiredFeature: "supplier_management"
    },
    {
      url: ":companyId/suppliers/:supplierId",
      component: ViewSupplierDetailed, intent: 'read', requiredFeature: "supplier_management"
    },

    {
      url: ":companyId/invoices",
      component: InvoiceList, intent: 'read',
      requiredFeature: "invoicing"
    },
    {
      url: ":companyId/supplier-invoices",
      component: SupplierInvoiceList, intent: 'read',
      requiredFeature: "supplier_invoices"
    },
    {
      // Unified intake for incoming supplier invoices. Gated by the same
      // supplier_invoices flag as the supplier list itself — if a tenant
      // can't see supplier invoices, they shouldn't see the inbox feeding
      // it. The page works regardless of which intake channels are
      // configured (Mailgun forward / Gmail / Outlook / manual upload).
      url: ":companyId/inbox",
      component: InboxPage, intent: 'read', requiredFeature: "inbox"
    },
    {
      url: ":companyId/supplier-invoices/:invoiceId",
      component: ViewSupplierInvoice, intent: 'read',
      requiredFeature: "supplier_invoices"
    },
    {
      url: ":companyId/edit-supplier-invoice/:invoiceId",
      component: CreateSupplierInvoice,
      requiredFeature: "supplier_invoices"
    },
    {
      url: ":companyId/create-invoices",
      component: InvoiceForm,
      requiredFeature: "invoicing"
    },
    {
      url: ":companyId/create-credit-note/:invoiceId",
      component: CreditNoteForm,
      requiredFeature: "invoicing"
    },
    {
      url: ":companyId/edit-Credit-note/:invoiceId",
      component: CreditNoteForm,
      requiredFeature: "invoicing"
    },

    // Add these routes in the routes array (around line 275, after the existing credit note routes)
    {
      url: ":companyId/create-credit-note-new/:invoiceId",
      component: CreditNoteGenerator,
      requiredFeature: "invoicing"
    },
    {
      url: ":companyId/edit-credit-note-new/:invoiceId",
      component: CreditNoteGenerator,
      requiredFeature: "invoicing"
    },

    {
      url: ":companyId/create-supplier-invoices",
      component: CreateSupplierInvoice,
      requiredFeature: "supplier_invoices"
    },
    {
      url: ":companyId/edit-invoice/:invoiceId",
      component: InvoiceForm,
      requiredFeature: "invoicing"
    },
    {
      url: ":companyId/view-invoice/:invoiceId",
      component: ViewInvoice, intent: 'read',
      requiredFeature: "invoicing"
    },
    {
      url: ":companyId/view-invoice-new/:invoiceId",
      component: InvoiceDetailBootstrap, intent: 'read',
      requiredFeature: "invoicing"
    },
    // Quotes (Offerter) hidden from the UI until the module gets the same
    // editor as invoices (2026-09-09). The public acceptance route in App.js
    // stays so links already sent to customers keep working.
    /*
    {
      url: ":companyId/quotes",
      component: QuoteList,
      requiredFeature: "invoicing_quotes"
    },
    {
      url: ":companyId/create-quote",
      component: QuoteForm,
      requiredFeature: "invoicing_quotes"
    },
    {
      url: ":companyId/edit-quote/:quoteId",
      component: QuoteForm,
      requiredFeature: "invoicing_quotes"
    },
    {
      url: ":companyId/view-quote/:quoteId",
      component: ViewQuote,
      requiredFeature: "invoicing_quotes"
    },

    {
      url: ":companyId/create-quote-new",
      component: QuoteGeneratorBootstrap,
      requiredFeature: "invoicing_quotes"
    },
    {
      url: ":companyId/edit-quote-new/:quoteId",
      component: QuoteForm,
      requiredFeature: "invoicing_quotes"
    },
    {
      url: ":companyId/view-quote-new/:quoteId",
      component: ViewQuote,
      requiredFeature: "invoicing_quotes"
    },
    */


    { url: ":companyId/verifications", component: Verifications, intent: 'read', requiredFeature: "bookkeeping" },

    // Tillgångar (fixed assets) — universal feature, no requiredFeature on
    // the base routes (only AI detection/tax optimizer are premium-gated,
    // and those gates live server-side / in later phases). The tax step is
    // deliberately ungated here too: the backend's 403 renders as an
    // upgrade card so the feature stays discoverable. NOTE: /assets/tax
    // must precede /assets/:assetId — the Switch matches in order.
    { url: ":companyId/assets", component: AssetList, intent: 'read', requiredFeature: "asset_management" },
    { url: ":companyId/assets/tax", component: AssetTaxStep, requiredFeature: "asset_tax_optimizer" },
    { url: ":companyId/assets/:assetId", component: AssetDetail, intent: 'read', requiredFeature: "asset_management" },


    //Employees
    { url: ":companyId/employees", component: EmployeeList, intent: 'read', requiredFeature: "personell_management" },
    //{ url: "employee/:id", component: ViewEmployee },
    { url: ":companyId/create-employee", component: NewEmployee, requiredFeature: "personell_management" },
    { url: ":companyId/edit-employee/:id", component: EditEmployee, requiredFeature: "personell_management" },
    { url: ":companyId/schedule", component: ViewSchedule, requiredFeature: "personell_management" },

    //Contracts

    //{ url: "employee/:id/newcontract", component: NewContract },


    /// Settings
    { url: ":companyId/settings", component: CompanySettings },
    { url: ":companyId/settings/:section", component: CompanySettings },
    { url: ":companyId/user/:userId/settings", component: UserSettings },
    { url: ":companyId/user/:userId/settings/:section", component: UserSettings },
    { url: ":companyId/templates/:templateId", component: TemplateEditor },

    // Bokslut (year-end wizard) — the bare route picks the most recently
    // ended fiscal year and redirects to the parameterized one. Specific
    // before parameterized: the Switch matches in order.
    { url: ":companyId/year-end", component: YearEndPage, intent: 'read', requiredFeature: "year_end" },
    { url: ":companyId/year-end/:fiscalYearId", component: YearEndPage, intent: 'read', requiredFeature: "year_end" },

    // Skatteplanering — the what-if page (lön, K10, periodiseringsfond).
    // Admin-gated server-side (403 → info card in the page).
    { url: ":companyId/tax-planning", component: TaxPlanningPage, requiredFeature: "tax_planning" },

    /// Reporting
    { url: ":companyId/vat-periods", component: VatReportingPeriods, intent: 'read', requiredFeature: "vat_reporting" },
    // Legacy URLs kept as redirect shims — both land on the canonical
    // /:companyId/vat-periods/:vatPeriodId below (VatPeriodDetails).
    { url: ":companyId/vat-period/:vatPeriodId", component: VatPeriodDetails, intent: 'read', requiredFeature: "vat_reporting" },
    { url: ":companyId/vat-period-stepper/:vatPeriodId", component: VatPeriodDetails, intent: 'read', requiredFeature: "vat_reporting" },
    { url: ":companyId/periodisk-sammanstallning", component: PeriodiskSammanstallning, requiredFeature: "vat_reporting" },

    { url: ":companyId/reports/mainledger", component: MainLedgerReport, intent: 'read', requiredFeature: "accounting_reports" },
    { url: ":companyId/reports/balance", component: BalanceReport, intent: 'read', requiredFeature: "accounting_reports" },
    { url: ":companyId/reports/result", component: ResultReport, intent: 'read', requiredFeature: "accounting_reports" },
    { url: ":companyId/reports/asset-register", component: AssetRegisterReport, intent: 'read', requiredFeature: "asset_management" },
    { url: ":companyId/reports/asset-note", component: AssetNoteReport, intent: 'read', requiredFeature: "asset_tax_optimizer" },

    // AI
    {
      url: ":companyId/ai-assistant",
      component: BookkeepingChatInterface,
      requiredFeature: "ai_assistant"
    },
    {
      // Vad Finn vet (Phase 4 trust surface) — reads member-level; per-row write
      // authority is the gateway's decision.
      url: ":companyId/vad-finn-vet",
      component: WhatFinnKnowsPage,
      requiredFeature: "ai_assistant"
    },


    /// pages
    { url: "page-register", component: Registration },
    { url: "page-login", component: Login },
    { url: "page-forgot-password", component: ForgotPassword },
    { url: "page-error-400", component: Error400 },
    { url: "page-error-403", component: Error403 },
    { url: "page-error-404", component: Error404 },
    { url: "page-error-500", component: Error500 },
    { url: "page-error-503", component: Error503 },
  ];

  // Show loading indicator while features are loading
  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading features...</span>
        </div>
      </div>
    );
  }


  return (
    <TodoProvider>
      <div id={`${!pagePath ? "main-wrapper" : ""}`}
        className={`${!pagePath ? "show" : "mh100vh"}  ${menuToggle ? "menu-toggle" : ""
          }`}
      >
        {!pagePath && <Nav companyId={companyId} />}
        {!pagePath && <MobileMenuToggle />}

        <div className={`${!pagePath ? "content-body" : ""} ${fullBleed ? "content-body-flush" : ""}`}>
          <div
            className={`${!pagePath && !fullBleed ? "container-md" : ""}`}
            style={fullBleed ? undefined : { minHeight: window.screen.height - 60 }}
          >
            <BillingContentGate>
            {!pagePath && !fullBleed && companyId && <AgentEmailBanner companyId={companyId} />}
            <Switch>
              {routes.map((data, i) => (
                <ProtectedRoute
                  key={i}
                  exact
                  path={`/${data.url}`}
                  component={data.component}
                  requiredFeature={data.requiredFeature}
                  intent={data.intent}
                />
              ))}

              <Route path="/:companyId/feature-disabled" component={FeatureDisabledPage} />

              {/*<Route path="/:companyId/edit-invoice/:id" component={EditInvoice} />*/}

              <FeatureRoute path="/:companyId/employee/:id/contract/:contractId/edit" component={EditContract} feature="personell_management" intent="write" />
              <FeatureRoute path="/:companyId/employee/:id/newcontract" component={NewContract} feature="personell_management" intent="write" />
              <FeatureRoute path="/:companyId/employee/:id" component={ViewEmployee} feature="personell_management" intent="read" />
              {/*<Route path="/:companyId/supplier-invoice/:id" component={EditInvoice} />*/}
              <FeatureRoute path="/:companyId/time-reporting" exact component={TimesheetPage} intent="read" feature="time_tracking" />
              <FeatureRoute path="/:companyId/time-reporting/timesheet" component={TimesheetPage} intent="read" feature="time_tracking" />
              <FeatureRoute path="/:companyId/projects/reports" component={ProjectReportsPage} intent="read" feature="project_management" />
              <FeatureRoute path="/:companyId/projects/:projectId/edit" component={ProjectEditPage} feature="project_management" />
              <FeatureRoute path="/:companyId/projects/:projectId" component={ProjectDetailsPage} intent="read" feature="project_management" />
              <FeatureRoute path="/:companyId/projects" exact component={ProjectsPage} intent="read" feature="project_management" />
              {/* Phase 2.5 — capability + feature both gated.
                  approval: time.approve.team admits managers (team) and
                    admin tier (all). Sidebar hides the link for non-managers
                    (Phase 2.0); this is the bookmark/typed-URL guard.
                  retention: tenant-wide GDPR purge — admin only. Composed
                    via requireRole='isAdmin' rather than a scope; retention
                    is not a per-employee resource so the scope axis doesn't
                    apply. */}
              <CapabilityRoute
                path="/:companyId/time-reporting/approval"
                component={ApprovalPage}
                feature="time_tracking"
                capability="time.approve.team"
                module="time-reporting.approve"
              />
              <CapabilityRoute
                path="/:companyId/time-reporting/retention"
                component={RetentionPage}
                feature="time_tracking"
                requireRole="isAdmin"
                module="admin"
              />
              <CapabilityRoute
                path="/:companyId/expenses/approvals"
                component={ExpenseApprovalQueuePage}
                feature="expense_management"
                capability="expense.approve.all"
                module="expenses.approve"
              />
              <FeatureRoute path="/:companyId/expenses" exact component={ExpensesPage} intent="read" feature="expense_management" />
              <Route path="/:companyId/todos" component={TodoPage} />
              <FeatureRoute path="/:companyId/documents" exact component={DocumentsPage} intent="read" feature="document_management" />
              <CapabilityRoute
                path="/:companyId/time-reporting/reports"
                component={ReportsPage}
                intent="read"
                feature="time_tracking"
                capability="time.report.all"
                module="time-reporting.report"
              />

              <FeatureRoute path="/:companyId/payroll/periods" component={PayrollPeriods} feature="payroll" intent="read" />
              <FeatureRoute path="/:companyId/payroll/semester" component={SemesterPage} feature="payroll" intent="write" />
              <FeatureRoute path="/:companyId/payroll/:year/:month" component={MonthlyPayrollPeriod} feature="payroll" intent="read" />
              <FeatureRoute path="/:companyId/payslip/:id" component={Payslip} feature="payroll" intent="read" />
              <FeatureRoute path="/:companyId/accounting/fiscal-years/:fiscalYearId" component={FiscalYearDetails} feature="bookkeeping" intent="read" />

              {/*<FeatureRoute path="/payroll/:year" component={MonthlyPayrollPeriod} feature="payroll" intent="read" />*/}
              <FeatureRoute path='/:companyId/edit-verification/:verificationId' component={EditVerification} feature="bookkeeping" intent="write" />
              <FeatureRoute path='/:companyId/copy-verification' component={CreateVerificationFromCopy} feature="bookkeeping" intent="write" />

              <FeatureRoute path='/:companyId/create-bookkeeping-entry' component={CreateBookkeepingEntry} feature="bookkeeping" intent="write" />
              <FeatureRoute path="/:companyId/manual-bookkeeping-entry" component={ManualBookkeepingEntry} feature="bookkeeping" intent="write" />

              <FeatureRoute path="/:companyId/vat-periods/:vatPeriodId" exact component={VatPeriodStepper} feature="vat_reporting" />

            </Switch>
            </BillingContentGate>
          </div>
        </div>
      </div>
      <ScrollToTop />
    </TodoProvider>
  );
};

export default Markup;
